import React from 'react'
import MockScopingTask from './MockScopingTask'

const MockScopingList = () => {
  return (
    React.createElement(React.Fragment, null
      , Array.from(Array(8).keys()).map((idx) => {
        return React.createElement(MockScopingTask, { key: idx, idx: idx,} )
      })
    )
  )
}

export default MockScopingList
